module.exports = __webpack_public_path__ + "assets/img/home-midea.967596b7.png";